export default __webpack_public_path__ + "static/media/icon-scroll-x.62b6957c.svg";